import { useTranslation } from 'react-i18next';

const advantages = [
  { numKey: 'adv.1.num', titleKey: 'adv.1.title', descKey: 'adv.1.desc', icon: 'ri-puzzle-2-line', color: '#FF2D78' },
  { numKey: 'adv.2.num', titleKey: 'adv.2.title', descKey: 'adv.2.desc', icon: 'ri-links-line', color: '#FF8C42' },
  { numKey: 'adv.3.num', titleKey: 'adv.3.title', descKey: 'adv.3.desc', icon: 'ri-rocket-line', color: '#FF2D78' },
  { numKey: 'adv.4.num', titleKey: 'adv.4.title', descKey: 'adv.4.desc', icon: 'ri-shield-check-line', color: '#FF8C42' },
  { numKey: 'adv.5.num', titleKey: 'adv.5.title', descKey: 'adv.5.desc', icon: 'ri-group-line', color: '#FF2D78' },
];

export default function AdvantagesSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-24 relative overflow-hidden">
      <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-primary/15 to-transparent hidden lg:block pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 bg-accent/10 border border-accent/20 rounded-full">
            <i className="ri-medal-line text-accent text-sm" />
            <span className="text-accent text-xs font-medium uppercase tracking-wider">{t('adv.tag')}</span>
          </div>
          <h2 className="text-4xl xl:text-5xl font-heading font-bold text-gray-900 mb-4">{t('adv.title')}</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">{t('adv.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {advantages.map((adv, i) => (
            <div
              key={i}
              className={`relative group bg-white border border-primary-100 rounded-2xl p-7 card-glow transition-all duration-300 hover:-translate-y-1 ${i === 4 ? 'lg:col-span-2 xl:col-span-1' : ''}`}
            >
              <div className="absolute top-4 right-5 text-7xl font-heading font-black opacity-5 leading-none select-none" style={{ color: adv.color }}>
                {t(adv.numKey)}
              </div>
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: `${adv.color}15`, border: `1px solid ${adv.color}30` }}>
                  <i className={`${adv.icon} text-xl`} style={{ color: adv.color }} />
                </div>
                <div>
                  <div className="text-xs font-mono font-bold mb-0.5" style={{ color: adv.color }}>{t(adv.numKey)}</div>
                  <h3 className="text-lg font-heading font-bold text-gray-900">{t(adv.titleKey)}</h3>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">{t(adv.descKey)}</p>
              <div className="absolute bottom-0 left-7 right-7 h-px opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: `linear-gradient(to right, transparent, ${adv.color}60, transparent)` }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
